import React, { useContext, useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import List from '@material-ui/core/List'
import CodeIcon from '@material-ui/icons/Code'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Typography from '@material-ui/core/Typography'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Button from '@material-ui/core/Button'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import Hidden from '@material-ui/core/Hidden'

import _firebaseContext from '../../contexts/firebaseContext'
import _appContext from '../../contexts/appContext'

import PromocodeListElement from './PromocodeListElement'
import PromocodeSettingsDialog from './PromocodeSettingsDialog'
import Options from '../Options'

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        maxWidth: 500,
        backgroundColor: theme.palette.background.paper,
    },
    inline: {
        display: 'inline',
    },
    listTitle: {
        marginTop: '15px',
        marginBottom: '15px',
    },
    formGroup: {
        marginTop: '15px',
        marginBottom: '15px',
    },
    field: {
        marginLeft: '15px',
    },
    block: {
        display: 'block',
    },
}))

export default function PromocodesList() {
    const [
        promocodeSettingDialogState,
        setPromocodeSettingDialogState,
    ] = useState(false)
    const [selectedPromocode, setSelectedPromocode] = useState(null)
    const classes = useStyles()
    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)
    const type = 'promocodes'

    const togglePromocodeSettingsDialog = (promocode = null) => {
        setSelectedPromocode(promocode)
        setPromocodeSettingDialogState(!promocodeSettingDialogState)
    }

    useEffect(() => {
        const fetchingState = firebaseContext.data.fetchingState[type]

        if (fetchingState) {
            appContext.startLoading()
        } else {
            appContext.endLoading()
        }
    })

    useEffect(() => {
        firebaseContext.startPromocodesListener()

        return () => {
            firebaseContext.closePromocodesListener()
        }
    }, [])


    const getPromocodes = (active = true) => {
        const promocodes = (firebaseContext.data[type] || []).filter((promocode) => promocode.data.isActive === active)
        promocodes.sort((a, b) => (b.data.createdDate?.toDate() || 0) - (a.data.createdDate?.toDate() || 0))
        return promocodes
    }

    const getPromocodesList = () => {
        const activePromocodes = getPromocodes(true)
        const disablePromocodes = getPromocodes(false)
        return activePromocodes.concat(disablePromocodes)
    }

    const handleCreate = async (event) => {
        let result = await firebaseContext.createPromocode()
        appContext.snackbar.showSnackbarMsg(result.message)
    }

    return (
        <>
            <Typography
                variant="h4"
                component="h1"
                className={classes.listTitle}
            >
                Список промокодов
            </Typography>
            <Button
                variant="contained"
                color="default"
                className={classes.addbtn}
                onClick={handleCreate}
            >
                Добавить промокод
            </Button>
            <List className={classes.root}>
                {getPromocodesList() === 0 ? (
                    <Typography variant="body1">
                        В системе пока нет промокодов
                    </Typography>
                ) : (
                    getPromocodesList().map((promocode) => (
                        <ListItem
                            key={promocode.id}
                            disabled={promocode.data.isActive === false}
                        >
                            <Hidden xsDown>
                                <ListItemIcon>
                                    <CodeIcon />
                                </ListItemIcon>
                            </Hidden>
                            <ListItemText
                                primary={
                                    promocode.data.promocode
                                        ? promocode.data.promocode
                                        : 'Промокод не назначен'
                                }
                                secondary={
                                    <>
                                        <PromocodeListElement
                                            title={'Вид подписки'}
                                            value={promocode.data.subscription}
                                            nullValueRepresent={
                                                'подписка не задана'
                                            }
                                        />

                                        <PromocodeListElement
                                            title={'Количество активаций'}
                                            value={
                                                promocode.data
                                                    .promocodeActivationCount
                                            }
                                            nullValueRepresent={
                                                'ни разу не активирован'
                                            }
                                        />

                                        <PromocodeListElement
                                            title={
                                                'Максимальное количество активаций'
                                            }
                                            value={
                                                promocode.data
                                                    .promocodeActivationMaxCount
                                            }
                                            nullValueRepresent={'не указано'}
                                        />

                                        <PromocodeListElement
                                            title={'Истекает'}
                                            value={
                                                promocode.data.expiryTime &&
                                                promocode.data.expiryTime
                                                    .toDate()
                                                    .toLocaleDateString('ru-RU')
                                            }
                                            nullValueRepresent={
                                                'действует бессрочно'
                                            }
                                        />

                                        <PromocodeListElement
                                            title={'Создан'}
                                            value={
                                                promocode.data.createdDate
                                                    ?.toDate()
                                                    .toLocaleString('ru-RU')
                                            }
                                            nullValueRepresent={
                                                'не определено'
                                            }
                                        />

                                        <PromocodeListElement
                                            title={'Ссылка'}
                                            value={
                                                `https://myenergy.stream/promo/${promocode.data.promocode}`
                                            }
                                            nullValueRepresent={
                                                'нет'
                                            }
                                        />
                                    </>
                                }
                            />
                            <ListItemSecondaryAction>
                                <Options
                                    obj={promocode}
                                    addAction={null}
                                    editAction={() =>
                                        togglePromocodeSettingsDialog(promocode)
                                    }
                                    deleteAction={null}
                                />
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))
                )}
            </List>
            {selectedPromocode && (
                <PromocodeSettingsDialog
                    open={promocodeSettingDialogState}
                    handleClose={() => togglePromocodeSettingsDialog()}
                    promocode={selectedPromocode}
                />
            )}
        </>
    )
}
